<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" >
                <p class="form_sub_title">基础信息</p>
                <a-form-model-item ref="status" label="平台编码" prop="status">
                    <span class="form_span">{{ record.platfromcode }}</span>
                </a-form-model-item>
                <a-form-model-item ref="rolecode" v-show="record.rolecode" label="角色编码" prop="rolecode">
                    <span class="form_span">{{ record.rolecode }}</span>
                </a-form-model-item>
                <a-form-model-item ref="rolename" label="角色名称" prop="rolename">
                    <a-input v-if="is_vue_task" v-model="record.rolename" :disabled="disabled"
                        @blur=" () => { $refs.rolename.onFieldBlur(); }" />
                    <span v-else class="form_span">{{ record.rolename }}</span>
                </a-form-model-item>

                <a-form-model-item ref="status" label="有效性" prop="status">
                    <a-radio-group v-model="record.status" button-style="solid" style="margin-left:15px"
                        v-if="is_vue_task">
                        <a-radio-button value="1"> 有效</a-radio-button>
                        <a-radio-button value="0"> 无效</a-radio-button>
                    </a-radio-group>
                    <span v-else class="form_span">{{ record.status == '1' ? '有效' : '无效' }}</span>
                </a-form-model-item>

                <a-form-model-item ref="type" label="权限类型" prop="type">
                    <a-select v-if="is_vue_task" v-model="record.type" placeholder="">
                        <a-select-option value="0">普通权限</a-select-option>
                        <a-select-option value="1">系统权限</a-select-option>
                    </a-select>
                    <span v-else class="form_span">{{ record.type == '1' ? '系统权限' : '普通权限' }}</span>

                </a-form-model-item>

                <a-form-model-item label="说明" prop="remark">
                    <a-input v-if="is_vue_task" v-model="record.remark" :disabled="disabled" />
                    <span v-else class="form_span">{{ record.remark }}</span>
                </a-form-model-item>

                <template v-if="!is_auth">
                    <p  class="form_sub_title">选择对应的功能权限</p>
                    <a-tree v-model="checkedKeys" checkable :tree-data="treeData" :expanded-keys="expandedKeys"
                        :auto-expand-parent="autoExpandParent" @select="onSelect" @check="onCheck"
                        :checkStrictly="checkStrictly">
                    </a-tree>


                    <a-form-model-item  v-show="is_vue_task">
                        <a-button type="primary" @click="handleOk" style="margin-left:200px;">
                            保存
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="handleCancel">
                            取消
                        </a-button>
                    </a-form-model-item>
                </template>
                <template v-else>
                    <p class="form_sub_title">授权系统</p>

                    <a-row>
                        <a-col :span="12">
                            <SysAutoComplete @onSysCodeChange="handleSysChange"></SysAutoComplete>
                            <a-button type="primary" @click="handleAddSys" class="ml20">
                                添加
                            </a-button>
                        </a-col>
                    </a-row>
            
                    <a-row>
                        <a-col :span="24">
                            <a-input-search
                                v-model="keyword"
                                placeholder="输入关键字"
                                style="width: 470px"
                                @search="getAuthSys"
                                class="mt20"
                                />
                            <a-table :columns="columns1" :data-source="sysList" :loading="tLoading" :pagination="false" class="pt4 w100"
                                rowKey="syscode">
                                <template slot="operation" slot-scope="text, record">
                                    <div class="editable-row-operations">
                                        <a-button @click="handleDelete(record)">删除</a-button>
                                    </div>
                                </template>
                            </a-table>
                            
                        </a-col>
                    </a-row>
                    <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize"  @change="handlePageChange" style="padding-top:20px;"
                                show-less-items show-quick-jumper />
                    
                </template>
            </a-form-model>


        </a-card>
    </div>

</template>
<script>
// import {mapState} from "vuex";
import SysAutoComplete from '@/components/SysCodeAutoComplete'
let pagination ={
    page:1,
    pageSize:50,
    total:0
};
const columns1 = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width: 150
    },
    {
        title: '系统名',
        dataIndex: 'sysname',
        align: 'center',
        width: 150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: {customRender: 'operation'},
    }
];
const m_title = {
    'addrole': '新增角色',
    'detailrole': '查看角色',
    'editrole': '编辑角色',
    'authrole':'角色授权系统'
};
export default {
    components:{
        SysAutoComplete
    },
    data() {
        return {
            columns1,
            labelCol: {span: 6},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入角色名称', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout: 'inline',
            c_title: '',
            is_vue_task: true,
            disabled: this.$route.params.action == "detailrole" ? true : false,
            treeData: [],
            autoExpandParent: true,
            expandedKeys: [],
            checkedKeys: [],
            checkStrictly: true,
            record: {},
            is_auth:false,
            currentSys:'',
            sysList:[],
            tLoading:false,
            pagination,
            keyword:''
        };
    },

    methods: {
        handleAddSys(){
            if(!this.currentSys.syscode){
                this.message.warn('先选择系统')
                return
            }
            let that = this;
            that.tLoading = true;
            that.$store.dispatch({
                type: "ums/addRoleSys",
                showMsg: false,
                params: {
                    syscode:that.currentSys.syscode,
                    sysname:that.currentSys.sysname,
                    createuser:that.G.getCurrentUser().username,
                    rolecode:that.record.rolecode,
                    urlparams: false
                }
            }).then((res) => {
                if(res.data.success == '1'){
                    this.getAuthSys()
                }
            });

        },
        handlePageChange(v){
            this.pagination.page = v;
            this.getAuthSys();
        },
        getAuthSys(){
            let that = this;
            that.tLoading = true;
            that.$store.dispatch({
                type: "ums/queryRoleSys",
                showMsg: false,
                params: {
                    rolecode:that.record.rolecode,
                    keyword:that.keyword,
                    ...that.pagination,
                    urlparams: false
                }
            }).then((res) => {
                this.tLoading = false;
                let result = res.data.data;
                this.sysList = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.page = result.page;
            });
        },
        handleDelete(record){
            let that = this;
            that.tLoading = true;
            that.$store.dispatch({
                type: "ums/delRoleSys",
                showMsg: false,
                params: {
                    syscode:record.syscode,
                    rolecode:that.record.rolecode,
                    urlparams: false
                }
            }).then((res) => {
                if(res.data.success == '1'){
                    this.getAuthSys()
                }
            });
        },
        handleSysChange(v,originData){
            let result = originData.filter(item => { return item.syscode == v });
            if(result.length > 0){
                this.currentSys = result[0]  
            }
            else{
                this.currentSys = {
                    syscode:'',
                    sysname:''
                }
            }
        },
        onSelect() {
        },
        onCheck() {
        },
        handleOk() {
            let checked_keys = this.checkedKeys
            if (this.checkedKeys.checked) {
                checked_keys = this.checkedKeys.checked;
            }
            let that = this
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const {params} = this.$route;
                    this.record.roles = checked_keys.join(',')
                    if (params.action == 'editrole') {
                        //编辑
                        this.$store
                            .dispatch({
                                type: "ums/updateRoleConfig",
                                params: that.record
                            })
                            .then((response) => {
                                console.log(response)
                                this.handleCancel();
                                this.confirmLoading = false;
                            });
                    } else if (params.action == 'addrole') {
                        //新增
                        this.$store
                            .dispatch({
                                type: "ums/insertRoleConfig",
                                params: that.record
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }

                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        //获取菜单列表
        getMenuTree(selectedmenu, platfromcode) {
            let c_paramsA = {
                // ...this.searchP,
                platfromcode: platfromcode,
            }
            this.$store.dispatch({
                type: "ums/searchMenuConfigTree",
                showMsg: false,
                params: {...c_paramsA, urlparams: false}
            }).then((res) => {
                let origin_data = res.data.data;
                //排序
                origin_data.sort(function (a, b) {
                    return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                });
                for (let index = 0; index < origin_data.length; index++) {
                    const element = origin_data[index];
                    element.title = element.name;
                    element.key = element.id;
                    this.expandedKeys.push(element.key)
                    this.handleTreeData(element)
                }

                this.treeData = origin_data
                this.checkedKeys = selectedmenu;
            });
        },
        //递归树结构
        handleTreeData(treeItem) {
            treeItem.title = treeItem.name;
            treeItem.key = treeItem.id;
            this.expandedKeys.push(treeItem.key)
            treeItem.children = [];
            if (treeItem.submenuList.length == 0) {
                treeItem.style = 'display:inline;'
            }
            for (let index = 0; index < treeItem.submenuList.length; index++) {
                const r_child = treeItem.submenuList[index];
                treeItem.children.push(this.handleTreeData(r_child))

            }
            return treeItem;
        }
    },
    mounted() {
        // this.record
        const {query, params} = this.$route;
        this.is_vue_task = params.action != 'detailrole' && params.action != 'authrole'
        this.is_auth = params.action == 'authrole'
        
        this.c_title = m_title[params.action]
        let that = this
        if (query.platfromcode == '') {
            alert("请选择平台")
            return false
        }
        if (params.action != "addrole") {
            that.$store.dispatch({
                type: "ums/searchRoleConfig",
                params: query,
                showMsg: false
            }).then((res) => {
                let selectmenu = res.data.data[0].roles.split(',')
                let platfromcode = res.data.data[0].platfromcode
                that.record = res.data.data[0]
                that.getMenuTree(selectmenu, platfromcode);
                if(that.is_auth){
                    that.pagination.page = 1;

                    that.getAuthSys()
                }
            })
        } else {
            // this.$store.dispatch({
            //     type: "rolecenter/getEmptyRole",
            //     params: query,
            //     showMsg: false
            // })
            that.record = {
                platfromcode: query.platfromcode

            }
            this.getMenuTree([], query.platfromcode);
        }

        

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}

.ant-input[disabled] {
    color: rgba(0, 0, 0, 0.55);
}

.form_span {
    font-size: 14px;
    font-weight: bolder;
}

.form_sub_title {
    padding-top: 20px;
    font-weight: bold;
}
</style>
